import * as yup from 'yup';

export const programSchema = yup.array().of(
  yup.object({
    kind: yup.string(),
    version: yup.string(),
    name: yup.string().required('Software name is required.'),
    product_url: yup
      .string()
      .matches(
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
        'The URL must be a valid URL including the http(s):// protocol.'
      )
      .required('Software URL is required.'),
    description: yup.string(),
    dependencies: yup.string(),
    vendor_contact_email: yup.string().email(),
    slug: yup
      .string()
      .matches(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug must be a valid slug.')
      .required('Slug is required.'),
    vendor_website_url: yup
      .string()
      .matches(
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
        'The URL must be a valid URL including the http(s):// protocol.'
      )
      .required('Website URL is required.')
  })
);

export const accountSchema = yup.object({
  vendor_name: yup.string().required('Vendor name is required.'),
  url: yup
    .string()
    .matches(
      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
      'The URL must be a valid URL including the http(s):// protocol.'
    ),
  contact_email: yup.string().email().required('Vendor email is required.'),
  contact_person: yup.string().required('Person of contact is required.'),
  timezone: yup.string().required('Timezone is required.')
});
